import React, { useState, useEffect } from "react";
// import "~@flaticon/flaticon-uicons/css/all/all";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FiYoutube, FiLinkedin } from "react-icons/fi";
function Media() {
  const [hideIcons, setHideIcons] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.getElementById("footer");
      if (footer) {
        const footerTop = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        // Check if footer is visible
        if (footerTop <= windowHeight) {
          setHideIcons(true); // Hide icons
        } else {
          setHideIcons(false); // Show icons
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    // Clean up event listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <div className={`social-icons ${hideIcons ? "hide" : "show"}`}>
        <a
          className="btn rounded-full mb-3 facebook w-12 h-12 flex items-center justify-center"
          href="https://www.facebook.com/profile.php?id=100092529031387"
          target="_blank"
        >
          <FaFacebook className="text-xl" />
        </a>
        <a
          className="btn rounded-full mb-3 instagram w-12 h-12 flex items-center justify-center"
          href="https://www.instagram.com/wara_technology?igsh=dzcxdG0yZzk0MThj"
          target="_blank"
        >
          <FaInstagram className="text-xl" />
        </a>
        <a
          className="btn rounded-full mb-3 linkedin w-12 h-12 flex items-center justify-center"
          href="#"
          target="_blank"
        >
          <FiLinkedin className="text-xl" />
        </a>
        <a
          className="btn rounded-full mb-3 youtube w-12 h-12 flex items-center justify-center"
          href="#"
          target="_blank"
        >
          <FiYoutube className="text-xl" />
        </a>
      </div>

      {/* Style */}
      <style jsx>{`
        .social-icons {
          position: fixed;
          top: 53%;
          right: 10px;
          transform: translateY(-50%);
          z-index: 1000;
          transition: opacity 1s ease, transform 1s ease; /* Smooth transition */
        }
        .social-icons.show {
          opacity: 1;
          transform: translateY(0);
        }
        .social-icons.hide {
          opacity: 0;
          transform: translateX(20px); /* Slide down a bit when hiding */
        }
        .social-icons a {
          display: flex;
          justify-content: center; /* Center icon horizontally */
          align-items: center; /* Center icon vertically */
          width: 35px; /* Smaller circle width */
          height: 35px; /* Smaller circle height */
          border-radius: 50%; /* Make it circular */
          color: white;
          font-size: 11px; /* Smaller icon size */
          transition: background 0.3s, transform 0.3s; /* Smooth transition */
        }
        .social-icons a.facebook {
          background-color: #4267b2;
        }
        .social-icons a.twitter {
          background-color: #1da1f2;
        }
        .social-icons a.instagram {
          background-image: linear-gradient(45deg, #833ab4, #fd1d1d, #fcb045);
        }
        .social-icons a.linkedin {
          background-color: #0077b5;
        }
        .social-icons a.youtube {
          background-color: #ff0000;
        }
        .social-icons a:hover {
          opacity: 0.85;
          transform: scale(1.05);
          background: var(--bs-dark);
          color: var(--bs-primary);
        }
      `}</style>
    </div>
  );
}

export default Media;
